module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "loading": _vm.loading,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    class: _vm.iconClass
  }), _vm._v("\n  " + _vm._s(_vm.buttonText) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ee22f2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/button/src/main.vue
// module id = 1470
// module chunks = 124